import Collapsible from './Collapsible'

export { Collapsible }
